<template>
  <div class="quickpay-page">
    <header class="header">
      <div class="header-left">
        <div class="header-mch">{{ '快捷收银台' }}</div>
        <div class="header-sub">请确认持卡人信息并完成短信验证</div>
      </div>
      <div class="header-img">
        <!-- <img :src="avatar" alt="" /> -->
      </div>
    </header>

    <section class="steps">
      <div class="step-item" :class="{ active: step === 1, done: step > 1 }">
        <div class="step-index">1</div>
        <div class="step-text">填写持卡人信息</div>
      </div>
      <div class="step-line"></div>
      <div class="step-item" :class="{ active: step === 2 }">
        <div class="step-index">2</div>
        <div class="step-text">短信验证并支付</div>
      </div>
    </section>

    <div class="quickpay-card">
      <div class="amount-block" v-if="payOrderInfo.amount">
        <div class="amount-title">支付金额</div>
        <div class="amount-value">￥{{ (payOrderInfo.amount / 100).toFixed(2) }}</div>
        <div class="amount-sub">订单号：{{ payOrderInfo.mchOrderNo || '-' }}</div>
      </div>

      <div class="form-group">
        <label>持卡人姓名</label>
                <div class="form-input-wrap" :class="{ 'is-readonly': isFieldReadonly('cardName') }">
          <i class="icon icon-user"></i>
          <input type="text" v-model.trim="form.cardName" placeholder="请输入姓名" :readonly="isFieldReadonly('cardName')">
        </div>
      </div>
      <div class="form-group">
        <label>身份证号</label>
        <div class="form-input-wrap" :class="{ 'is-readonly': isFieldReadonly('idNo') }">
          <i class="icon icon-idcard"></i>
          <input type="text" v-model.trim="form.idNo" placeholder="请输入身份证号" :readonly="isFieldReadonly('idNo')">
        </div>
      </div>
      <div class="form-group">
        <label>银行卡号</label>
        <div class="form-input-wrap" :class="{ 'is-readonly': isFieldReadonly('bankNo') }">
          <i class="icon icon-card"></i>
          <input type="text" v-model.trim="form.bankNo" placeholder="请输入银行卡号" :readonly="isFieldReadonly('bankNo')">
        </div>
      </div>
      <div class="form-group">
        <label>预留手机号</label>
        <div class="form-input-wrap" :class="{ 'is-readonly': isFieldReadonly('phone') }">
          <i class="icon icon-phone"></i>
          <input type="tel" v-model.trim="form.phone" placeholder="请输入银行预留手机号" :readonly="isFieldReadonly('phone')">
        </div>
        <p class="field-tip">仅用于本次银行短信验证，不会泄露您的隐私。</p>
      </div>

      <div class="bnt-pay-inline" v-if="step === 1">
        <button
          class="bnt-pay-text"
          :class="{ 'is-loading': applyLoading }"
          @click="handleSubmit"
          :disabled="applyLoading"
        >
          <span v-if="applyLoading">处理中...</span>
          <span v-else>下一步，获取验证码</span>
        </button>
      </div>

      <div class="form-group" v-if="step === 2">
        <label>短信验证码</label>
        <div class="sms-row">
          <div class="form-input-wrap flex-1">
            <i class="icon icon-sms"></i>
            <input type="text" v-model.trim="form.smsCode" placeholder="请输入收到的验证码">
          </div>
          <button
            class="sms-btn"
            :disabled="smsCountdown > 0 || sendingSms"
            @click.prevent="resendSms"
          >
            {{ smsCountdown > 0 ? smsCountdown + 's' : (sendingSms ? '发送中...' : '重新发送') }}
          </button>
        </div>
        <p class="field-tip" v-if="form.phone">
          验证码已发送至 {{ maskedPhone }} ，请在 {{ smsCountdown || 60 }} 秒内完成输入。
        </p>
      </div>

      <div class="bnt-pay-inline" v-if="step === 2">
        <button
          class="bnt-pay-text is-step2"
          :class="{ 'is-loading': confirmLoading }"
          @click="handleSubmit"
          :disabled="confirmLoading"
        >
          <span v-if="confirmLoading">处理中...</span>
          <span v-else>确认支付</span>
        </button>
      </div>

      <p class="tip">本页面由支付平台提供加密保护，请确认环境安全后再输入银行卡信息。</p>
    </div>

    <div class="processing-mask" v-if="processing">
      <div class="processing-card">
        <div class="spinner"></div>
        <p>{{ processingText || '支付处理中，请勿关闭页面…' }}</p>
      </div>
    </div>

    <div class="dialog-mask" v-if="dialog.visible" @click.self="closeDialog">
      <div class="dialog-wrap" :class="{ 'dialog-error': dialog.type === 'error' }">
        <div class="dialog-header">
          <span class="dialog-icon" v-if="dialog.type === 'error'">⚠️</span>
          {{ dialog.title || '温馨提示' }}
        </div>
        <div class="dialog-body">{{ dialog.message }}</div>
        <div class="dialog-footer">
          <button class="dialog-btn" :class="{ 'dialog-btn-error': dialog.type === 'error' }" @click="closeDialog">{{ dialog.confirmText || '我知道了' }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getPayOrderInfo, getPayOrderInfoState, applyQuickPay, confirmQuickPay } from '@/api/api'
import config from '@/config'

export default {
  data () {
    return {
      form: {
        cardName: '',
        idNo: '',
        bankNo: '',
        phone: '',
        smsCode: ''
      },
      payOrderInfo: {},
      avatar: require('../../assets/icon/wx.svg'),
      step: 1,
      applyLoading: false,
      confirmLoading: false,
      sendingSms: false,
      smsCountdown: 0,
      countdownTimer: null,
      applyTicket: null,
      processing: false,
      processingText: '',
      pollTimer: null,
      pollRetry: 0,
      fieldLocks: {
        cardName: false,
        idNo: false,
        bankNo: false,
        phone: false
      },
      manualFormLocked: false,
      dialog: {
        visible: false,
        title: '',
        message: '',
        confirmText: '',
        type: 'info' // info, error, success, warning
      }
    }
  },
  computed: {
    maskedPhone () {
      if (!this.form.phone) return ''
      return this.form.phone.replace(/^(\d{3})\d{4}(\d{4})$/, '$1****$2')
    }
  },
  mounted () {
    this.initFormData()
    this.fetchPayOrderInfo()
  },
  beforeDestroy () {
    this.clearTimer()
    this.stopOrderPolling()
  },
  methods: {
    initFormData () {
      // 从路由参数或查询参数获取预填充信息
      const params = this.$route.params
      const query = this.$route.query
      
      if (params.cardName || query.cardName) {
        this.form.cardName = params.cardName || query.cardName || ''
      }
      if (params.idNo || query.idNo) {
        this.form.idNo = params.idNo || query.idNo || ''
      }
      if (params.bankNo || query.bankNo) {
        this.form.bankNo = params.bankNo || query.bankNo || ''
      }
      if (params.phone || query.phone) {
        this.form.phone = params.phone || query.phone || ''
      }
    },
    fetchPayOrderInfo () {
      getPayOrderInfo().then(res => {
        this.payOrderInfo = res || {}
        // 如果订单信息中有客户信息，也填充到表单
        if (res) {
          if (res.customerName && !this.form.cardName) {
            this.form.cardName = res.customerName
            this.lockField('cardName')
          }
          if (res.customerIdcard && !this.form.idNo) {
            this.form.idNo = res.customerIdcard
            this.lockField('idNo')
          }
          if (res.customerBankCard && !this.form.bankNo) {
            this.form.bankNo = res.customerBankCard
            this.lockField('bankNo')
          }
          if (res.customerPhone && !this.form.phone) {
            this.form.phone = res.customerPhone
            this.lockField('phone')
          }
        }
      }).catch(err => {
        this.$router.push({ name: config.errorPageRouteName, params: { errInfo: err.msg } })
      })
    },
    validateStepOne () {
      if (!this.form.cardName) {
        this.showDialog('请输入持卡人姓名')
        return false
      }
      if (!/^[0-9A-Za-z]{15,18}$/.test(this.form.idNo)) {
        this.showDialog('身份证号格式不正确')
        return false
      }
      if (!/^\d{12,23}$/.test(this.form.bankNo)) {
        this.showDialog('银行卡号格式不正确')
        return false
      }
      if (!/^1\d{10}$/.test(this.form.phone)) {
        this.showDialog('手机号格式不正确')
        return false
      }
      return true
    },
    handleSubmit () {
      if (this.step === 1) {
        this.handleApply()
      } else {
        this.handleConfirm()
      }
    },
    handleApply () {
      if (this.applyLoading || !this.validateStepOne()) {
        return
      }
      this.applyLoading = true
      this.sendingSms = true
      applyQuickPay({
        cardName: this.form.cardName,
        idNo: this.form.idNo,
        bankNo: this.form.bankNo,
        phone: this.form.phone
      }).then(res => {
        this.applyTicket = res.ticket || null
        this.step = 2
        this.manualFormLocked = true
        this.form.smsCode = ''
        this.startCountdown()
        this.showDialog('验证码已发送至您的手机，请填写后确认支付。')
      }).catch(err => {
        this.$router.push({ name: config.errorPageRouteName, params: { errInfo: err.msg } })
      }).finally(() => {
        this.applyLoading = false
        this.sendingSms = false
      })
    },
    handleConfirm () {
      if (this.confirmLoading) {
        return
      }
      if (!this.form.smsCode || this.form.smsCode.length < 4) {
        this.showDialog('请输入正确的验证码', '验证码错误', '确定', 'error')
        return
      }
      this.confirmLoading = true
      confirmQuickPay({
        ticket: this.applyTicket,
        smsCode: this.form.smsCode
      }).then(res => {
        // 状态未知，开始轮询
          console.log('响应参数{}', res)
          this.processing = true
          this.processingText = '支付处理中，请勿关闭页面…'
          this.startOrderPolling()

        // 判断支付状态：0-订单生成, 1-支付中, 2-支付成功, 3-支付失败
        // const orderState = res && (res.orderState !== undefined ? res.orderState : res.state)
        // const returnUrl = res && res.returnUrl
        
        // if (orderState === 2) {
        //   // 支付成功
        //   this.gotoSuccess(returnUrl)
        // } else if (orderState === 3) {
        //   // 支付失败
        //   this.gotoFail(res.errMsg || res.errMsg || '支付失败，请重试', returnUrl)
        // } else if (orderState === 1 || orderState === 0) {
        //   // 支付中或订单生成，开始轮询
        //   this.processing = true
        //   this.processingText = '支付处理中，请勿关闭页面…'
        //   this.startOrderPolling()
        // } else if (returnUrl) {
        //   // 状态未知但有返回地址，直接跳转
        //   location.href = returnUrl
        // } else {
          
        // }
      }).catch(err => {
        // 验证码错误或其他错误，显示错误弹框
        const errMsg = err.msg || err.message || '操作失败，请重试'
        
        // 判断是否为验证码错误
        if (errMsg.includes('验证码') || errMsg.includes('验证') || errMsg.includes('错误') || errMsg.includes('过期')) {
          this.showDialog(errMsg, '验证码错误', '确定', 'error')
          // 清空验证码输入框，方便用户重新输入
          this.form.smsCode = ''
        } else {
          // 其他错误，跳转到失败页面
          this.gotoFail(errMsg)
        }
      }).finally(() => {
        this.confirmLoading = false
      })
    },
    resendSms () {
      if (this.sendingSms || this.smsCountdown > 0) {
        return
      }
      this.sendingSms = true
      applyQuickPay({
        cardName: this.form.cardName,
        idNo: this.form.idNo,
        bankNo: this.form.bankNo,
        phone: this.form.phone
      }).then(res => {
        this.applyTicket = res.ticket || this.applyTicket
        this.startCountdown()
        this.showDialog('验证码已重新发送，请注意查收。')
      }).catch(err => {
        this.$router.push({ name: config.errorPageRouteName, params: { errInfo: err.msg } })
      }).finally(() => {
        this.sendingSms = false
      })
    },
    startCountdown () {
      this.smsCountdown = 60
      this.clearTimer()
      this.countdownTimer = setInterval(() => {
        if (this.smsCountdown <= 1) {
          this.clearTimer()
          this.smsCountdown = 0
          return
        }
        this.smsCountdown -= 1
      }, 1000)
    },
    clearTimer () {
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer)
        this.countdownTimer = null
      }
    },
    startOrderPolling () {
      // this.stopOrderPolling()
      // 只清理轮询定时器，不重置 processing 状态，避免刚设置的遮罩被立刻关闭
      if (this.pollTimer) {
        clearInterval(this.pollTimer)
        this.pollTimer = null
      }
      this.pollRetry = 0
      this.pollTimer = setInterval(() => {
        this.pollRetry++
        getPayOrderInfoState().then(info => {
          // 支付状态：0-订单生成, 1-支付中, 2-支付成功, 3-支付失败
          const state = info && (info.state !== undefined ? info.state : info.orderState)
          console.log("获取到支付订单状态为={}", state)
          
          if (state === 2) {
            // 支付成功
            this.stopOrderPolling()
            this.gotoSuccess(info.returnUrl)
          } else if (state === 3) {
            // 支付失败
            this.stopOrderPolling()
            this.gotoFail(info.errMsg || '支付失败，请重试', info.returnUrl)
          } else if (this.pollRetry >= 100) {
            // 轮询15次（30秒）后仍未确认，提示用户
            this.stopOrderPolling()
            this.gotoFail('支付状态暂未确认，请稍后在订单详情中查看', info.returnUrl)
          }
          // state === 0 或 state === 1 时继续轮询
        }).catch((err) => {
          // 查询失败，如果已经轮询多次，则提示失败；否则继续尝试
          if (this.pollRetry >= 10000) {
            this.stopOrderPolling()
            const errMsg = err.msg || err.message || '查询支付状态失败，请联系客服'
            this.gotoFail(errMsg)
          }
        })
      }, 2000)
    },
    stopOrderPolling () {
      if (this.pollTimer) {
        clearInterval(this.pollTimer)
        this.pollTimer = null
      }
      this.processing = false
      this.processingText = ''
    },
    gotoSuccess (returnUrl) {
      this.stopOrderPolling()
      try {
        this.$router.push({
          name: 'PaySuccess',
          query: {
            mchOrderNo: (this.payOrderInfo && this.payOrderInfo.mchOrderNo) || '',
            amount: (this.payOrderInfo && this.payOrderInfo.amount) || '',
            mchName: (this.payOrderInfo && this.payOrderInfo.mchName) || '',
            returnUrl: returnUrl || ''
          }
        }).catch(err => {
          // 路由跳转失败，尝试直接跳转URL
          console.error('路由跳转失败:', err)
          const queryStr = new URLSearchParams({
            mchOrderNo: (this.payOrderInfo && this.payOrderInfo.mchOrderNo) || '',
            amount: (this.payOrderInfo && this.payOrderInfo.amount) || '',
            mchName: (this.payOrderInfo && this.payOrderInfo.mchName) || '',
            returnUrl: returnUrl || ''
          }).toString()
          location.href = `#/pay/success?${queryStr}`
        })
      } catch (err) {
        console.error('跳转成功页面失败:', err)
        // 如果路由跳转失败，尝试直接跳转URL
        const queryStr = new URLSearchParams({
          mchOrderNo: (this.payOrderInfo && this.payOrderInfo.mchOrderNo) || '',
          amount: (this.payOrderInfo && this.payOrderInfo.amount) || '',
          mchName: (this.payOrderInfo && this.payOrderInfo.mchName) || '',
          returnUrl: returnUrl || ''
        }).toString()
        location.href = `#/pay/success?${queryStr}`
      }
    },
    gotoFail (errMsg, returnUrl) {
      this.stopOrderPolling()
      try {
        this.$router.push({
          name: 'PayFail',
          query: {
            mchOrderNo: (this.payOrderInfo && this.payOrderInfo.mchOrderNo) || '',
            amount: (this.payOrderInfo && this.payOrderInfo.amount) || '',
            errMsg: errMsg || '支付失败，请稍后再试',
            returnUrl: returnUrl || '',
            token: config.cacheToken || ''
          }
        }).catch(err => {
          // 路由跳转失败，尝试直接跳转URL
          console.error('路由跳转失败:', err)
          const queryStr = new URLSearchParams({
            mchOrderNo: (this.payOrderInfo && this.payOrderInfo.mchOrderNo) || '',
            amount: (this.payOrderInfo && this.payOrderInfo.amount) || '',
            errMsg: errMsg || '支付失败，请稍后再试',
            returnUrl: returnUrl || '',
            token: config.cacheToken || ''
          }).toString()
          location.href = `#/pay/fail?${queryStr}`
        })
      } catch (err) {
        console.error('跳转失败页面失败:', err)
        // 如果路由跳转失败，尝试直接跳转URL
        const queryStr = new URLSearchParams({
          mchOrderNo: (this.payOrderInfo && this.payOrderInfo.mchOrderNo) || '',
          amount: (this.payOrderInfo && this.payOrderInfo.amount) || '',
          errMsg: errMsg || '支付失败，请稍后再试',
          returnUrl: returnUrl || '',
          token: config.cacheToken || ''
        }).toString()
        location.href = `#/pay/fail?${queryStr}`
      }
    },
    isFieldReadonly (field) {
      return !!(this.fieldLocks[field] || this.manualFormLocked)
    },
    lockField (field) {
      if (this.fieldLocks[field]) {
        return
      }
      this.$set(this.fieldLocks, field, true)
    },
    showDialog (msg, title, confirmText, type = 'info') {
      this.dialog.visible = true
      this.dialog.message = msg || ''
      this.dialog.title = title || '温馨提示'
      this.dialog.confirmText = confirmText || '我知道了'
      this.dialog.type = type
    },
    closeDialog () {
      this.dialog.visible = false
    }
  }
}
</script>

<style lang="css" scoped>
@import './pay.css';

.quickpay-page {
  min-height: 100vh;
  background: #f5f6fb;
}

.quickpay-card {
  background: #fff;
  border-radius: 12px;
  padding: 20px 16px 18px;
  margin: 12px 12px 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}
.amount-block {
  text-align: center;
  margin-bottom: 20px;
}
.amount-title {
  font-size: 13px;
  color: #999;
}
.amount-value {
  font-size: 28px;
  font-weight: bold;
  margin-top: 6px;
  color: #333;
}
.amount-sub {
  margin-top: 6px;
  font-size: 12px;
  color: #999;
}
.form-group {
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
}
.form-group label {
  font-size: 15px;
  color: #333;
  margin-bottom: 8px;
  font-weight: 500;
}
.form-group input {
  height: 48px;
  border-radius: 8px;
  padding: 0 12px;
  font-size: 15px;
  color: #333;
}
.form-input-wrap {
  position: relative;
  display: flex;
  align-items: center;
  background: #fafbff;
  border-radius: 8px;
  border: 1px solid #e2e3ec;
  padding: 0 12px 0 36px;
  transition: all 0.3s;
}
.form-input-wrap.is-readonly {
  background: #f5f5f5;
  border-color: #d9d9d9;
  cursor: not-allowed;
}
.form-input-wrap.is-readonly input {
  color: #666;
  cursor: not-allowed;
}
.form-input-wrap input {
  flex: 1;
  border: none;
  background: transparent;
  padding-left: 0;
  font-size: 15px;
  color: #333;
}
.form-input-wrap input:focus {
  outline: none;
}
.form-input-wrap input:readonly {
  cursor: not-allowed;
  color: #666;
}
.form-group input:focus {
  border-color: #1678ff;
  outline: none;
}
.field-tip {
  margin-top: 4px;
  font-size: 12px;
  color: #b0b3c0;
}
.sms-row {
  display: flex;
  align-items: center;
  gap: 12px;
}
.sms-row .form-input-wrap.flex-1 {
  flex: 1;
}
.sms-btn {
  width: 110px;
  height: 44px;
  border: none;
  border-radius: 8px;
  background: linear-gradient(135deg, #07c160, #0bbf92);
  color: #fff;
  cursor: pointer;
  font-size: 14px;
}
.sms-btn:disabled {
  background: #ccc;
  cursor: not-allowed;
}
.tip {
  font-size: 12px;
  color: #bbb;
  text-align: center;
  margin-top: 12px;
}

.steps {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 24px 4px;
}
.step-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #c0c3d2;
  font-size: 12px;
}
.step-index {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  border: 1px solid #c0c3d2;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 4px;
  background: #fff;
}
.step-text {
  white-space: nowrap;
}
.step-item.active .step-index {
  border-color: #1678ff;
  background: #1678ff;
  color: #fff;
}
.step-item.active .step-text {
  color: #1678ff;
}
.step-item.done .step-index {
  border-color: #07c160;
  background: #07c160;
  color: #fff;
}
.step-item.done .step-text {
  color: #07c160;
}
.step-line {
  flex: 1;
  height: 1px;
  background: linear-gradient(to right, #d8dbe7, #f5f6fb);
  margin: 0 10px;
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 16px 8px;
}
.header-left {
  flex: 1;
}
.header-mch {
  font-size: 17px;
  font-weight: 600;
  color: #222;
}
.header-sub {
  margin-top: 4px;
  font-size: 12px;
  color: #999;
}
.header-img img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}

.bnt-pay-inline {
  margin-top: 8px;
  margin-bottom: 16px;
}
.bnt-pay-inline .bnt-pay-text {
  width: 100%;
  height: 48px;
  border-radius: 24px;
  border: none;
  background: linear-gradient(135deg, #07c160, #12b987);
  color: #fff;
  font-size: 15px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(7, 193, 96, 0.3);
  cursor: pointer;
  transition: all 0.3s;
}
.bnt-pay-inline .bnt-pay-text:active {
  transform: scale(0.98);
  opacity: 0.9;
}
.bnt-pay-inline .bnt-pay-text.is-step2 {
  background: linear-gradient(135deg, #1678ff, #2d8bff);
  box-shadow: 0 4px 12px rgba(22, 120, 255, 0.3);
}
.bnt-pay-inline .bnt-pay-text.is-loading {
  opacity: 0.7;
  cursor: not-allowed;
}
.bnt-pay-inline .bnt-pay-text:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

/* 保留原有的固定底部按钮样式，以防其他地方使用 */
.bnt-pay {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 8px 16px 16px;
  background: linear-gradient(to top, #ffffff, rgba(255, 255, 255, 0.8));
  box-shadow: 0 -4px 10px rgba(0, 0, 0, 0.03);
}
.bnt-pay-text {
  width: 100%;
  height: 48px;
  border-radius: 24px;
  border: none;
  background: linear-gradient(135deg, #07c160, #12b987);
  color: #fff;
  font-size: 15px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 18px rgba(7, 193, 96, 0.32);
}
.bnt-pay-text.is-step2 {
  background: linear-gradient(135deg, #1678ff, #2d8bff);
  box-shadow: 0 8px 18px rgba(22, 120, 255, 0.32);
}
.bnt-pay-text.is-loading {
  opacity: 0.8;
}

.icon {
  position: absolute;
  left: 10px;
  font-style: normal;
  font-size: 14px;
  color: #a8aec2;
}
.icon-user::before {
  content: '👤';
}
.icon-idcard::before {
  content: '🪪';
}
.icon-card::before {
  content: '💳';
}
.icon-phone::before {
  content: '📱';
}
.icon-sms::before {
  content: '🔐';
}

.dialog-mask {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
}
.dialog-wrap {
  width: 80%;
  max-width: 320px;
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.18);
  overflow: hidden;
}
.dialog-header {
  padding: 18px 18px 8px;
  font-size: 16px;
  font-weight: 600;
  text-align: center;
  color: #222;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}
.dialog-icon {
  font-size: 20px;
}
.dialog-body {
  padding: 8px 18px 16px;
  font-size: 14px;
  color: #555;
  text-align: center;
  line-height: 1.6;
}
.dialog-wrap.dialog-error .dialog-header {
  color: #ff4757;
}
.dialog-wrap.dialog-error .dialog-body {
  color: #666;
}
.dialog-footer {
  padding: 0 18px 18px;
}
.dialog-btn {
  width: 100%;
  height: 44px;
  border-radius: 22px;
  border: none;
  background: linear-gradient(135deg, #1678ff, #2d8bff);
  color: #fff;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s;
}
.dialog-btn:active {
  opacity: 0.9;
  transform: scale(0.98);
}
.dialog-btn-error {
  background: linear-gradient(135deg, #ff4757, #ff6b7a);
}
.processing-mask {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 900;
  backdrop-filter: blur(2px);
}
.processing-card {
  width: 220px;
  background: #fff;
  border-radius: 16px;
  padding: 24px 18px;
  text-align: center;
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.15);
}
.spinner {
  width: 48px;
  height: 48px;
  margin: 0 auto 16px;
  border: 4px solid #e9efff;
  border-top-color: #1678ff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}
.processing-card p {
  font-size: 14px;
  color: #555;
  line-height: 1.6;
}
@keyframes spin {
  to { transform: rotate(360deg); }
}
</style>



